import { useEffect, useState } from 'react';
import {
    TABLE_BOTTOM_GAP,
    TABLE_HEADER_HEIGHT,
    TABLE_PAGINATION_HEIGHT,
} from './reconPaymentHelpers';

/**
 * Viewport-based DataTable fixedHeaderScrollHeight for reconciliation lists.
 */
const useReconTableScrollHeight = ({ containerRef, dataLength, loading }) => {
    const [tableScrollHeight, setTableScrollHeight] = useState('600px');

    useEffect(() => {
        const updateTableHeight = () => {
            const containerTop =
                containerRef.current?.getBoundingClientRect().top ?? 220;
            const maxBodyHeight =
                window.innerHeight -
                containerTop -
                TABLE_HEADER_HEIGHT -
                TABLE_PAGINATION_HEIGHT -
                TABLE_BOTTOM_GAP;
            setTableScrollHeight(`${Math.max(maxBodyHeight, 280)}px`);
        };

        const raf = window.requestAnimationFrame(updateTableHeight);
        window.addEventListener('resize', updateTableHeight);
        return () => {
            window.cancelAnimationFrame(raf);
            window.removeEventListener('resize', updateTableHeight);
        };
    }, [containerRef, dataLength, loading]);

    return tableScrollHeight;
};

export default useReconTableScrollHeight;
